import React, { useEffect } from "react";
import useStyles from "../styles";
import FormControl from "@material-ui/core/FormControl";
import { Controller } from "react-hook-form";
import { Switch } from "antd";
import { withRouter } from "react-router";
import { renderErrorCreatePool } from "../../../../utils/validate";

function BlockUser(props: any) {
  const classes = useStyles();
  const { setValue, errors, control, user } = props;
  const renderError = renderErrorCreatePool;

  useEffect(() => {
    if (user && user.status !== undefined) {
      // Set initial value based on user status
      setValue("status", user.status); // 1 = Active, 2 = Blocked
    }
  }, [user, setValue]);

  return (
    <>
      <FormControl component="fieldset">
        <Controller
          control={control}
          name="status"
          render={({ value }) => {
            return (
              <Switch
                onChange={(checked) => {
                  // If checked is true, user is active (1); otherwise blocked (2)
                  setValue("status", checked ? 1 : 2);
                }}
                checked={value === 1} // Checked means Active
                checkedChildren="Active"
                unCheckedChildren="Blocked"
              />
            );
          }}
        />

        <p className={classes.formErrorMessage}>
          {renderError(errors, "status")}
        </p>
      </FormControl>
      <br />
    </>
  );
}

export default withRouter(BlockUser);
